module.exports = function(words) {
  words = words.replace(/ /g, "_");

  words = words
    .toLowerCase()
    .replace(/\b[a-z]/g, letter => letter.toLowerCase());
  return words;
};
